<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, attachments } = useMessageContext();

const attachment = computed(() => attachments.value?.[0] || {});

const url = computed(() => content.value?.match(/https?:\/\/[^\s<>"']+/i)?.[0]);

const title = computed(() => {
  const lines = content.value
    ?.split('\n')
    .map(line => line.trim())
    .filter(Boolean);

  return lines?.find(line => line !== url.value) || url.value;
});

const host = computed(() => {
  try {
    return new URL(url.value).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
});

const imageUrl = computed(
  () => attachment.value.thumbUrl || attachment.value.dataUrl
);
</script>

<template>
  <BaseBubble class="overflow-hidden p-0" data-bubble-name="link-preview">
    <a
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      class="skip-context-menu block w-72 max-w-full text-n-slate-12 no-underline"
    >
      <img
        v-if="imageUrl"
        :src="imageUrl"
        class="w-full aspect-[1.91/1] object-cover bg-n-slate-3"
        alt=""
      />
      <div class="px-3 py-2 bg-n-alpha-2">
        <div class="font-medium line-clamp-2 leading-5">
          {{ title }}
        </div>
        <div v-if="host" class="mt-1 text-xs uppercase text-n-slate-11">
          {{ host }}
        </div>
      </div>
    </a>
  </BaseBubble>
</template>
